module.exports = __webpack_public_path__ + "static/media/illuEuropraid2017_1_02_thumb.99d57e91.png";